'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSlick = require('react-slick');

var _reactSlick2 = _interopRequireDefault(_reactSlick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomSlider = function (_React$PureComponent) {
    (0, _inherits3.default)(CustomSlider, _React$PureComponent);

    function CustomSlider() {
        (0, _classCallCheck3.default)(this, CustomSlider);
        return (0, _possibleConstructorReturn3.default)(this, (CustomSlider.__proto__ || (0, _getPrototypeOf2.default)(CustomSlider)).apply(this, arguments));
    }

    (0, _createClass3.default)(CustomSlider, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                props = (0, _objectWithoutProperties3.default)(_props, ['children']);

            var settings = (0, _extends3.default)({
                slidesToShow: 4,
                slidesToScroll: 4,
                infinite: false,
                className: 'gift__items',
                prevArrow: _react2.default.createElement(SliderPreviousButton, null),
                nextArrow: _react2.default.createElement(SliderNextButton, null),
                responsive: [{
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }] }, props);
            return _react2.default.createElement(
                _reactSlick2.default,
                settings,
                children
            );
        }
    }]);
    return CustomSlider;
}(_react2.default.PureComponent);

var SliderPreviousButton = function (_React$PureComponent2) {
    (0, _inherits3.default)(SliderPreviousButton, _React$PureComponent2);

    function SliderPreviousButton() {
        (0, _classCallCheck3.default)(this, SliderPreviousButton);
        return (0, _possibleConstructorReturn3.default)(this, (SliderPreviousButton.__proto__ || (0, _getPrototypeOf2.default)(SliderPreviousButton)).apply(this, arguments));
    }

    (0, _createClass3.default)(SliderPreviousButton, [{
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                currentSlide = _props2.currentSlide,
                slideCount = _props2.slideCount,
                className = _props2.className,
                props = (0, _objectWithoutProperties3.default)(_props2, ['currentSlide', 'slideCount', 'className']);

            return _react2.default.createElement(
                'button',
                (0, _extends3.default)({}, props, { className: "arrow arrow--left " + className }),
                _react2.default.createElement(
                    'svg',
                    { width: '100%', height: '100%', viewBox: '0 0 19 54' },
                    _react2.default.createElement('path', { className: 'arrow-path', d: 'M17.707,0.707l-17,26l17,26' })
                )
            );
        }
    }]);
    return SliderPreviousButton;
}(_react2.default.PureComponent);

var SliderNextButton = function (_React$PureComponent3) {
    (0, _inherits3.default)(SliderNextButton, _React$PureComponent3);

    function SliderNextButton() {
        (0, _classCallCheck3.default)(this, SliderNextButton);
        return (0, _possibleConstructorReturn3.default)(this, (SliderNextButton.__proto__ || (0, _getPrototypeOf2.default)(SliderNextButton)).apply(this, arguments));
    }

    (0, _createClass3.default)(SliderNextButton, [{
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                currentSlide = _props3.currentSlide,
                slideCount = _props3.slideCount,
                className = _props3.className,
                props = (0, _objectWithoutProperties3.default)(_props3, ['currentSlide', 'slideCount', 'className']);

            return _react2.default.createElement(
                'button',
                (0, _extends3.default)({}, props, { className: "arrow arrow--right " + className }),
                _react2.default.createElement(
                    'svg',
                    { width: '100%', height: '100%', viewBox: '0 0 19 54' },
                    _react2.default.createElement('path', { className: 'arrow-path', d: 'M0.707,52.707l17,-26l-17,-26' })
                )
            );
        }
    }]);
    return SliderNextButton;
}(_react2.default.PureComponent);

exports.default = CustomSlider;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step1/Slider.js
// module id = 751
// module chunks = 0